import {Injectable} from '@angular/core';
export interface ViewQrRequestParam {
    id: number;
    name: string;
}
@Injectable()
export class ViewQRService {}